"use strict";

/* General + Third-Party */
import jQuery from 'jquery';
import { lazyload } from './globals/lazyload';
import Alpine from 'alpinejs';
import { Fancybox } from "@fancyapps/ui";

import "@fancyapps/ui/dist/fancybox/fancybox.css";


import Swiper from 'swiper/bundle';
import 'swiper/css';

// Access Apline function to the window object
window.Alpine = Alpine
window.Swiper = Swiper;
window.Fancybox = Fancybox;

/* Layout-Parts */
import { nav } from './layout/navigation';

/* Blocks */
import { gallerySliderInit, galleryFancyboxInit  } from '../../blocks/gallery/script';


jQuery(document).ready(_ => {
  // General + Third-Party
  Alpine.start();
  lazyload();

  //Layout-Parts
  nav();

  //Blocks
  gallerySliderInit();
  galleryFancyboxInit();

});
